import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/v1'
const BASEURL_DEV = BASEURL + '/ParmManage'

const parkManage = {
    Statistics(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/OperateStatement/Statistics`,
            params
        })
    },
    OperateStatementAudit(data) {
        return $http({
            method: 'post',
            url: `${BASEURL_DEV}/OperateStatement/Audit`,
            data
        })
    },
    OperateStatementAuditRecordList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/OperateStatementAuditRecord/List`,
            params
        })
    },
    ParkFillInAuditRecordList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/ParkFillInAuditRecord/List`,
            params
        })
    },
    ParkFillInAudit(data) {
        return $http({
            method: 'post',
            url: `${BASEURL_DEV}/ParkFillIn/Audit`,
            data
        })
    },
    OperateStatementAttachmentList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/OperateStatementAttachment/List`,
            params
        })
    },
    OperateStatementAttachmentBatchAdd(data) {
        return $http({
            method: 'post',
            url: `${BASEURL_DEV}/OperateStatementAttachment/BatchAdd`,
            data
        })
    },
    OperateStatementDetail(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/OperateStatement/Detail`,
            params
        })
    },
    OperateStatementEdit(data) {
        return $http({
            method: 'post',
            url: `${BASEURL_DEV}/OperateStatement/Edit`,
            data
        })
    },
    OperateStatementPage(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/OperateStatement/Page`,
            params
        })
    },
    ParkFillInDetailList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/ParkFillInDetail/List`,
            params
        })
    },
    ParkFillInBatchAdd(data) {
        return $http({
            method: 'post',
            url: `${BASEURL_DEV}/ParkFillInDetail/BatchAdd`,
            data
        })
    },
    ParkFillInPage(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/ParkFillIn/Page`,
            params
        })
    },
    //添加花名册记录
    ParkFillInEdit(data) {
        return $http({
            method: 'post',
            url: `${BASEURL_DEV}/ParkFillIn/Edit`,
            data
        })
    },
    ParkList(params) {
        return $http({
            method: 'get',
            url: `${BASEURL_DEV}/Park/List`,
            params
        })
    },

}

export default parkManage
